import { SectionLayout } from "@/shared/ui/layouts/SectionLayout";
import Typography from "@/shared/ui/Typography";
import Button from "@/shared/ui/buttons/Button";
import { useAppDispatch } from "@/app/store/hooks";
import { requestFormModalOpen } from "@/widgets/modal/model/slice";

export function MainSection() {

    const dispatch = useAppDispatch();

    const handleFindYourProperty = () => {
        dispatch(
            requestFormModalOpen({
                title: 'Записаться на консультацию',
                text: 'Наш эксперт свяжется с вами в ближайшее время, чтобы подобрать подходящую недвижимость или ответить на интересующие вопросы',
            })
        );
    };

    
    return (
        <SectionLayout
            className="h-[600px] md:h-[700px] bg-[url('/images/backgrounds/main.jpg')] bg-center bg-cover"
            containerClassName="relative h-full flex items-center justify-center"
        >
            <div className="flex flex-col md:mb-[50px] gap-[20px] md:gap-[40px] items-center ">
                <Typography tag="h1">KRASOTA</Typography>
                <Typography tag="h2" className="text-[14px] font-medium">
                    Санкт-Петербург
                </Typography>
            </div>
            <div className="absolute z-0 bottom-[20px] md:bottom-[32px]">
                <Button
                    className="text-blue bg-white-50 glass transition-colors duration-300 ease-in-out origin-left hover:text-white hover:bg-blue"
                    iconType="search"
                    onClick={handleFindYourProperty}
                >
                    Найти свою недвижимость
                </Button>
            </div>
        </SectionLayout>
    );
}
